import { apiClient } from '@/services/apiClient';
import { Routes } from './routes';
import { useMutation } from '@tanstack/react-query';
import type { PriceBreakdown } from '@/types/checkout';

export const useApplyCoupon = () => {
  return useMutation({
    mutationFn: async (couponCode: string) => {
      const response = await apiClient.get<PriceBreakdown>(`${Routes.APPLY_COUPON}?promoCodeName=${couponCode}`);
      return response;
    },
  });
};
export const useCancelCoupon = () => {
  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.get(`${Routes.CANCEL_COUPON}`);
      return response;
    },
  });
};
